import { FaCheck, FaTimes } from "react-icons/fa";
import Card from "../../../components/Card";

export default function SystemHealthCard({ health, formatUptime, formatBytes }) {
  if (!health) return null;
  return (
    <Card className="mb-6">
      <h2 className="text-xl font-semibold mb-4 text-text">System Health</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <p className="text-sm text-text opacity-70">Database Status</p>
          <p className={`text-lg font-bold flex items-center gap-2 ${health.database === "connected" ? "text-secondary" : "text-accent"}`}>
            {health.database === "connected" ? <><FaCheck /> Connected</> : <><FaTimes /> Disconnected</>}
          </p>
        </div>
        <div>
          <p className="text-sm text-text opacity-70">Uptime</p>
          <p className="text-lg font-bold text-text">{formatUptime(health.uptime)}</p>
        </div>
        <div>
          <p className="text-sm text-text opacity-70">Node Version</p>
          <p className="text-lg font-bold text-text">{health.nodeVersion}</p>
        </div>
        <div>
          <p className="text-sm text-text opacity-70">Memory Usage</p>
          <p className="text-lg font-bold text-text">{formatBytes(health.memory.heapUsed)} / {formatBytes(health.memory.heapTotal)}</p>
        </div>
      </div>
    </Card>
  );
}
